import { MouseEvent, TouchEvent } from 'react';
import { tv } from 'tailwind-variants';

import ChevronCompactLeftIcon from '../../icons/ChevronCompactLeftIcon';
import ChevronCompactRightIcon from '../../icons/ChevronCompactRightIcon';
import { ValueInfo } from './ValueInfo';
import { HANDLE_WIDTH, HandleType } from './types';

const handle = tv({
  base: 'absolute bottom-0 top-0 z-10 flex cursor-ew-resize select-none items-center justify-center transition-colors',
  variants: {
    color: {
      gray: 'bg-gray-30 dark:bg-gray-75 text-gray-90 dark:text-white',
      violet: 'bg-violet dark:bg-violet text-white dark:text-white',
    },
    side: {
      start: 'rounded-l-lg',
      end: 'rounded-r-lg',
    },
  },
  compoundVariants: [],
  defaultVariants: {
    color: 'gray',
  },
});

export const Handle = ({
  open,
  side,
  pos,
  value,
  color,
  handleMouseDown,
  format,
  hideHandleInfo,
}: {
  open: boolean;
  side: HandleType;
  pos: number;
  value: number;
  handleMouseDown: (side: HandleType) => (e: MouseEvent | TouchEvent) => void;
  color?: 'gray' | 'violet';
  format?: (value: number) => string;
  hideHandleInfo?: boolean;
}) => {
  return (
    <ValueInfo open={open && !hideHandleInfo} value={value} format={format}>
      <div
        className={handle({ side, color })}
        style={{
          left:
            side === 'start' ? `calc(${pos}% - ${HANDLE_WIDTH}px)` : `${pos}%`,
          width: `${HANDLE_WIDTH}px`,
        }}
        onMouseDown={handleMouseDown(side)}
        onTouchStart={handleMouseDown(side)}
      >
        {side === 'start' ? (
          <ChevronCompactLeftIcon />
        ) : (
          <ChevronCompactRightIcon />
        )}
      </div>
    </ValueInfo>
  );
};
//side === 'end' ? `calc(${pos}% - ${HANDLE_WIDTH}px)` :
